import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 10l3 -3l3 3","key":"svg-0"}],["path",{"d":"M9 14l3 3l3 -3","key":"svg-1"}]]

const IconDirection = createReactComponent('outline', 'direction', 'Direction', __iconNode);

export default IconDirection;